<template>
  <div class="pageTit">
    <dl>
      <dt>
        {{this.title}}
      </dt>
      <dd>{{this.description}}</dd>
    </dl>
    <div class="brandBox">
      <ticket-brand-select></ticket-brand-select>
    </div>
  </div>
</template>
<script>
import ticketBrandSelect from '@/components/menus/ticket/ticket_brand_select.vue'

export default {
  props: {
    title: String,
    description: String
  },
  data: () => {
    return {
    }
  },
  components: {
    ticketBrandSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/ticket_header.vue